import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import Select from "../../../componentsReusable/Select";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const ServiceProposalCooGroupSelect = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [value, setValue] = useState(props.value)
  const [loading, setLoading] = useState(false)
  const [serviceProposalCooGroups, setServiceProposalCooGroups] = useState([])

  useDidMountEffect(() => {
    fetchData()
  })

  useAfterUpdateEffect(() => {
    props.onChange(value)
  }, [value])

  useAfterUpdateEffect(() => {
    fetchData()
  }, [props.filters, props.initalRegistrationDate])

  useAfterUpdateEffect(() => {
    if(serviceProposalCooGroups.length === 1){
      setValue(serviceProposalCooGroups[0].QualColId)
    }else{
      if(!serviceProposalCooGroups.find(serviceProposalCooGroup => serviceProposalCooGroup.QualColId === value)){
        setValue(null)
      }
    }
  }, [serviceProposalCooGroups])

  const fetchData = () => {
    if(props.isDisabled){
      return
    }
    setLoading(true)

    apiUser.tecRmi.maintenance.serviceProposalCooGroups({
        ...getApiPrimaryParams(),
      ...props.filters,
      initalRegistrationDate: props.initalRegistrationDate,
    })
      .then(res => {
        setServiceProposalCooGroups(res.data)
      })
      .finally(() => setLoading(false))
  }

  return <Select
    isDisabled={props.isDisabled}
    isLoading={loading}
    onChange={setValue}
    options={serviceProposalCooGroups.map(serviceProposalCooGroup => ({
      value: serviceProposalCooGroup.QualColId,
      label: serviceProposalCooGroup.QualColText,
    }))}
    value={value}
  />
};

ServiceProposalCooGroupSelect.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  initalRegistrationDate: PropTypes.string,
};

export default ServiceProposalCooGroupSelect;